<template>
  <div class="container-fluid text-center">
    <div class="col-md-12 ml-auto mr-auto">
      <div class="row">
        <div class="col-md-6" v-for="(i, key) in projects" :key=key>
          <project-view :data="i"> </project-view>
        </div>
      </div>
      <div>
          <br>
          <br>
        </div>
        <div class="row text-center">
          <div class="col-md-3">
          </div>
          <div class="col-md-6">
            <n-pagination
            type="default"
            :page-count="pagination.last_page"
            :per-page="pagination.per_page"
            :total="pagination.total"
            v-model="paginationIdx"
            class="justify-content-center"
            >
            </n-pagination>
          </div>
          <div class="col-md-3">
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import { Card, Pagination } from '@/components';
import { Divider, Button, MessageBox, Message } from 'element-ui';
import _ from 'lodash'
import ProjectView from './ProjectView';

import Investments from '@/providers/Investments'
const provider = new Investments()

export default {
  name: 'project-list-view',
  components: {
    Card,
    [Button.name]: Button,
    [Divider.name]: Divider,
    [Pagination.name]: Pagination,
    ProjectView
  },
  data() {
    return {
      pagination: {
          current_page: 1,
          per_page: 2
      },
      paginationIdx: 1,
      projects: []
    }
  },
  mounted() {
    this.getProjects()
  },
  props: ['status'],
  methods: {
    getProjects() {
      let filters = 'status=' + this.status.toUpperCase()
      provider.getInvestmentsPublic(this.pagination.per_page, this.paginationIdx, null, filters).then((response) => {
        this.projects = response.data.data
        this.pagination = response.data.meta.pagination
      }).catch((err) => {
        console.info('error investments request open')
        console.info(err)
      })
    },
  },
  watch: {
    paginationIdx(){
      this.getProjects()
    }
  }
};
</script>
<style>
</style>